module.exports = __webpack_public_path__ + "img/josephg.5e1c4e32.png";